var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManual(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 41,
    rx: 6,
    fill: "#414141"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4959 31.9313L25.1568 32.8599L24.2281 30.5208L32.1687 12.0613L35.4824 13.4919L27.4959 31.9313Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.785 12.7875L32.4745 11.3585L33.3033 9.51998C33.4282 9.22817 33.7016 8.98671 33.9971 8.86936C34.1425 8.81121 34.2979 8.78243 34.4545 8.78467C34.611 8.78691 34.7656 8.82013 34.9092 8.88242L35.9193 9.31839C36.0626 9.38024 36.1923 9.46985 36.3009 9.58204C36.4095 9.69423 36.4948 9.8268 36.552 9.9721C36.6702 10.2698 36.6807 10.6324 36.5548 10.9241L35.785 12.7875Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.13177 33.0768L9.61754 31.0873C11.0693 30.5608 12.6523 31.4346 12.9804 32.9436V32.9436C13.3085 34.4526 14.8915 35.3264 16.3432 34.7999L22.7433 32.4788",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0402 5.12598H10.7902C9.57712 5.12598 8.59375 6.10935 8.59375 7.3224V21.9653C8.59375 23.1783 9.57712 24.1617 10.7902 24.1617H21.0402C22.2532 24.1617 23.2366 23.1783 23.2366 21.9653V7.3224C23.2366 6.10935 22.2532 5.12598 21.0402 5.12598Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2549 8.78418H19.5763",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2549 12.4482H19.5763",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2549 16.1074H15.9156",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManual);
export default __webpack_public_path__ + "static/media/manual.64c6aac2813e1e932300a8663ad55118.svg";
export { ForwardRef as ReactComponent };